import type { LowScoreCriteria } from "../../Store/Reducers/MyPortfolioOverviewSlice";

export const LOW_SCORE_CRITERIA_KEY = "low_score_criteria";

export const DEFAULT_LOW_SCORE_CRITERIA: LowScoreCriteria = {
  renewal_enabled: true,
  renewal_days: 90,
  rl_gap_enabled: true,
  rl_gap_levels: 2,
  assessment_stale_enabled: true,
  assessment_stale_days: 90,
  signal_recency_enabled: false,
  signal_recency_days: 45,
};

const clampInt = (
  value: number,
  min: number,
  max: number,
  fallback: number
) => {
  if (!Number.isFinite(value)) return fallback;
  return Math.max(min, Math.min(max, Math.round(value)));
};

export const parseLowScoreCriteria = (
  raw: unknown
): LowScoreCriteria | null => {
  if (!raw || typeof raw !== "object") return null;
  const value = raw as Record<string, unknown>;
  const required = [
    "renewal_days",
    "renewal_enabled",
    "rl_gap_levels",
    "rl_gap_enabled",
    "assessment_stale_days",
    "assessment_stale_enabled",
    "signal_recency_days",
    "signal_recency_enabled",
  ];
  if (required.some(key => value[key] == null)) return null;
  return normalizeLowScoreCriteria(value);
};

export const normalizeLowScoreCriteria = (
  raw?: Partial<LowScoreCriteria> | null
): LowScoreCriteria => ({
  renewal_enabled: Boolean(
    raw?.renewal_enabled ?? DEFAULT_LOW_SCORE_CRITERIA.renewal_enabled
  ),
  renewal_days: clampInt(
    Number(raw?.renewal_days),
    1,
    365,
    DEFAULT_LOW_SCORE_CRITERIA.renewal_days
  ),
  rl_gap_enabled: Boolean(
    raw?.rl_gap_enabled ?? DEFAULT_LOW_SCORE_CRITERIA.rl_gap_enabled
  ),
  rl_gap_levels: clampInt(
    Number(raw?.rl_gap_levels),
    1,
    5,
    DEFAULT_LOW_SCORE_CRITERIA.rl_gap_levels
  ),
  assessment_stale_enabled: Boolean(
    raw?.assessment_stale_enabled ??
      DEFAULT_LOW_SCORE_CRITERIA.assessment_stale_enabled
  ),
  assessment_stale_days: clampInt(
    Number(raw?.assessment_stale_days),
    1,
    365,
    DEFAULT_LOW_SCORE_CRITERIA.assessment_stale_days
  ),
  signal_recency_enabled: false,
  signal_recency_days: clampInt(
    Number(raw?.signal_recency_days),
    1,
    365,
    DEFAULT_LOW_SCORE_CRITERIA.signal_recency_days
  ),
});
